export const ROLE_OPTIONS = [
  { value: 'Admin', label: 'Admin' },
  { value: 'AdminCoach', label: 'Admin & Coach' },
  { value: 'Coach', label: 'Coach' },
  { value: 'Cofounder', label: 'Cofounder' },
  { value: 'CommunityMember', label: 'Community Member' },
  { value: 'Evaluator', label: 'Evaluator' },
  { value: 'Expert', label: 'Expert' },
  { value: 'Mentor', label: 'Mentor' },
  { value: 'Staff', label: 'Staff' },
  { value: 'SubAdmin', label: 'SubAdmin' },
];

export const STATUS_OPTIONS = [
  {
    value: 'Active',
    label: 'Active',
  },
  {
    value: 'Archived',
    label: 'Archived',
  },
  {
    value: 'Deleted',
    label: 'Deleted',
  },
  {
    value: 'Deny',
    label: 'Deny',
  },
  {
    value: 'Pending',
    label: 'Pending',
  },
  {
    value: 'Unactive',
    label: 'Unactive',
  },
];
